/**
 * Singleton TanStack Query client. Exposing it via a module-level export
 * lets non-React code (Mapbox layers, Comlink workers, etc.) read cached
 * REST data with `queryClient.getQueryData(...)` without prop-drilling.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 2 },
  },
});
